import { render, staticRenderFns } from "./goosDetailsView.vue?vue&type=template&id=3b8692fc&scoped=true"
import script from "./goosDetailsView.vue?vue&type=script&lang=js"
export * from "./goosDetailsView.vue?vue&type=script&lang=js"
import style0 from "./goosDetailsView.vue?vue&type=style&index=0&id=3b8692fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8692fc",
  null
  
)

export default component.exports